/* tslint:disable */
/* eslint-disable */
export enum CyklusProduktStatusEnumDto {
  KundePaaVej = 'KundePaaVej',
  Aktiv = 'Aktiv',
  Svigt = 'Svigt'
}
